import { observer } from "mobx-react-lite";
import styled from "styled-components";

import { desktop } from "../desktop.ts";
import { useStores } from "../stores/RootStore.ts";
import { LoginPage } from "./pages/LoginPage.tsx";
import { SettingsPage } from "./pages/SettingsPage.tsx";
import { SetupPage } from "./pages/SetupPage.tsx";
import { StartPage } from "./pages/StartPage.tsx";
import { WelcomePage } from "./pages/WelcomePage.tsx";
import { WorkerListPage } from "./pages/WorkerListPage.tsx";
import { WorkerPage } from "./pages/WorkerPage.tsx";
import { GlobalStyle } from "./ui/GlobalStyle.ts";
import { Button, Muted, Row, Title } from "./ui/primitives.tsx";

const Header = styled.header`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid var(--border);
    background: var(--surface);
`;

const STATUS_TEXT = {
    offline: "offline, retrying",
    connecting: "connecting",
    online: "online",
    refused: "wrong password",
};

export const App = observer(function App() {
    const { connection, ui } = useStores();
    const loggedIn = connection.configured && connection.status !== "refused";
    // Before logging in, there's only setting up and logging in. Setting up needs the desktop app, so the browser starts at logging in.
    const outsidePages = desktop ? ["welcome", "login", "setup"] : ["login"];
    const refused = connection.configured && connection.status === "refused";
    const start = desktop && !refused ? ("welcome" as const) : ("login" as const);
    const outside = outsidePages.includes(ui.page.name) && !refused ? ui.page : { name: start };
    const page = loggedIn ? ui.page : outside;

    return (
        <>
            <GlobalStyle />
            <Header>
                <Row>
                    <Title
                        as="button"
                        onClick={() => ui.show({ name: "workers" })}
                        style={{ all: "unset", cursor: "pointer", fontWeight: 700 }}
                    >
                        mainions
                    </Title>
                    {loggedIn && <Muted>{STATUS_TEXT[connection.status]}</Muted>}
                </Row>
                {loggedIn && <Button onClick={() => ui.show({ name: "settings" })}>Settings</Button>}
            </Header>
            {page.name === "welcome" && <WelcomePage />}
            {page.name === "login" && <LoginPage />}
            {page.name === "settings" && <SettingsPage />}
            {page.name === "setup" && <SetupPage />}
            {page.name === "start" && <StartPage />}
            {page.name === "workers" && <WorkerListPage />}
            {page.name === "worker" && <WorkerPage workerKey={page.key} />}
        </>
    );
});
